import {
    FETCH_MESSAGES_BEGIN,
    FETCH_MESSAGES_SUCCESS,
    FETCH_MESSAGES_FAILURE,
    ADD_MESSAGE,
    SEND_MESSAGE_BEGIN,
    SEND_MESSAGE_SUCCESS,
    SHOW_WHATSAPP_CALLING_MODAL,
    HIDE_WHATSAPP_CALLING_MODAL,
    SEND_MESSAGE_FAILURE
} from '../constants'
import { BFFAgent } from 'BFFAgent'

// TODO Refactorizar para respetar el patron de una accion por archivo (One action one file)
export const fetchMessages = (conversationId, markAsRead) => {
    return async dispatch => {
        dispatch({ type: FETCH_MESSAGES_BEGIN })
        try {
            const res = await BFFAgent.Leads.fetchMessages(conversationId, markAsRead)
            if (res.data) {
                dispatch({
                    type: FETCH_MESSAGES_SUCCESS,
                    payload: res.data
                })
            }
            else {
                dispatch({
                    type: FETCH_MESSAGES_SUCCESS,
                    payload: { chat: [] }
                })
            }

        } catch (error) {
            dispatch({
                type: FETCH_MESSAGES_FAILURE,
                payload: { error: error.message }
            })
        }
    }
}

export const addMessage = message => {
    return {
        type: ADD_MESSAGE,
        payload: message
    }
}

export const buildOptimisticFileMessage = (file, objectUrl, userName) => {
    const isVideo = file.type?.startsWith('video/')
    const isImage = file.type?.startsWith('image/')
    const isAudio = file.type?.startsWith('audio/')
    const type = isVideo ? 'video' : isImage ? 'image' : isAudio ? 'audio' : 'document'
    const fileName = file.name || 'archivo'
    const media = {
        name: fileName,
        url: objectUrl,
        link: objectUrl,
        mimeType: file.type,
    }

    let mediaPayload
    if (isVideo) {
        mediaPayload = { video: media }
    } else if (isImage) {
        mediaPayload = { image: media }
    } else if (isAudio) {
        mediaPayload = { audio: { ...media, voice: true } }
    } else {
        // DocumentMessage reads message.file (same shape as persisted WA document messages)
        mediaPayload = {
            file: {
                name: fileName,
                url: objectUrl,
                type: file.type,
                size: file.size || 0,
            },
        }
    }

    return {
        id: `pending-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
        from: 'seller',
        status: 'sending',
        timestamp: Math.floor(Date.now() / 1000),
        type,
        name: userName,
        ...mediaPayload,
    }
}

export const showWhatsappCallingModal = lead => {
    return async dispatch => {
        dispatch({ type: SHOW_WHATSAPP_CALLING_MODAL, data: { lead } })
    }
}

export const hideWhatsappCallingModal = _ => {
    return async dispatch => {
        dispatch({ type: HIDE_WHATSAPP_CALLING_MODAL })
    }
}

export const sendMessage = (leadData, text, template, file) => {
    return async dispatch => {
        dispatch({ type: SEND_MESSAGE_BEGIN })
        try {
            await BFFAgent.Leads.sendMessage(leadData, text, template, file)
            dispatch({
                type: SEND_MESSAGE_SUCCESS,
                payload: text
            })
        } catch (error) {
            dispatch({
                type: SEND_MESSAGE_FAILURE,
                payload: { error: error.message }
            })
        }
    }
}
